import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Skip if is request to load config
        if (req.url.endsWith('config.json')) {
            return next.handle(req);
        }

        req = req.clone({
            setHeaders: {
                // 'Content-Type': contentType ? contentType : 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        });


        return next.handle(req);
    }
}
